<!--  -->
<template>
  <div class="all_box">
    <div class="tabselecr_box">
      <div class="search_box">
        <el-input v-model="query.staff_keywords" clearable style="width:400px;" placeholder="请输入员工编号/id/名字" />
        <el-input v-model="query.official_keywords" clearable style="width:400px;" placeholder="请输入公众号名称/appid" />
        <el-select v-model="query.onlyMe" placeholder="请选择" style="width:200px;">
          <el-option
            v-for="opt in accountarr"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value"
          />

        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      max-height="700"
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        width="80"
      />
      <el-table-column
        prop="name"
        label="员工姓名"
        align="center"
        width="200"
      />
      <el-table-column
        prop="employee_no"
        label="员工编号"
        align="center"
        width="300"
      />
      <el-table-column
        prop="corp_name"
        label="企业名称"
        align="center"
        width="200"
      />
      <el-table-column
        prop="corp_id"
        label="企业ID"
        align="center"
        width="320"
      />
      <el-table-column
        prop="user_id"
        label="公众号名称(appid)"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          {{ scope.row.account_name }}({{ scope.row.app_id }})
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="绑定时间"
        align="center"
        width="300"
      />
      <el-table-column
        prop="realName"
        label="绑定人"
        align="center"
        width="100"
      />
      <el-table-column
        prop="remark"
        label="操作"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="Unbinding(scope.row.id,scope.row.employee_no)">解绑</el-button>
          <!-- <el-button type="primary" size="mini" @click="priwew(scope.row)">预览oppid</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="27%"
    >
      <addbandAccount @updata="updata" />
    </el-dialog>
    <el-dialog
      title="解绑失败列表"
      :visible.sync="dialogVisiblewer"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="35%"
      max-height="500"
    >
      <el-table
        :data="erwdata"
        border
        style="width: 100%"
      >
        <!-- <el-table-column
          prop="id"
          label="策略列表ID"
          width="100"
          align="center"
        /> -->
        <el-table-column
          prop="sp_strategy_no"
          label="策略编号"
          width="310"
          align="center"
        />
        <el-table-column
          prop="employee_no"
          label="员工编号"
          align="center"
        />
      </el-table>
    </el-dialog>
    <el-dialog
      title="预览oppid"
      :visible.sync="dialogVisiblepriewer"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="27%"
    >
      <el-input v-model="textarea" placeholder="请输入预览oppid（请用英文逗号','进行间隔）" />
      <el-button type="primary" style="margin-top: 20px;" @click="sumbirtr">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { contactFollowUserslist, staffOfficialunBinding } from '@/api/officialaccount.js'
import { previewOpenidUpdate } from '@/api/bserw.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addbandAccount from './components/addbandAccount.vue'
export default {
  name: 'StaffAccount',
  components: { PaginationRight, addbandAccount },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        staff_keywords: null,
        official_keywords: null,
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内员工'
      }, {
        value: 2,
        label: '我关联的员工'
      }],
      total: null,
      tableData: [],
      loading: false,
      dialogVisible: false,
      erwdata: [],
      dialogVisiblewer: false,
      dialogVisiblepriewer: false,
      textarea: '',
      item: {}
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  methods: {
    async priwew(item) {
      console.log('item', item)
      this.dialogVisiblepriewer = true
      this.item = item
      this.textarea = item.open_ids
    },
    async list() {
      this.loading = true
      const data = await contactFollowUserslist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.staff_keywords = null
      this.query.official_keywords = null
      this.query.onlyMe = 2
      this.list()
    },
    add() {
      this.dialogVisible = true
    },
    Unbinding(id, employee_no) {
      this.$confirm('确定要解绑吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        staffOfficialunBinding({
          id: id,
          employee_no: employee_no
        }).then((res) => {
          if (res.data !== null) {
            console.log('1111', res)
            this.erwdata = res.data
            this.dialogVisiblewer = true
            this.$message.error('该员工有绑定策略')
            // this.list()
          } else {
            this.$message({
              type: 'success',
              message: '解绑成功!'
            })
            this.list()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑'
        })
      })
    },
    updata() {
      this.dialogVisible = false
      this.list()
    },
    async sumbirtr() {
      try {
        const data = await previewOpenidUpdate({
          employee_no: this.item.employee_no,
          app_id: this.item.app_id,
          open_ids: this.textarea
        })
        this.dialogVisiblepriewer = false
        this.textarea = ''
        this.$message({
          type: 'success',
          message: '预览成功!'
        })
        this.list()
        console.log('data', data)
      } catch {
        this.textarea = ''
        console.log('err')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.all_box{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
</style>
